/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ cloud: NonNullable<unknown>, partner: NonNullable<unknown> }} Partner_Dashboard_Kpi_Orgs_BadgeInputs */



/**
* | output |
* | --- |
* | "{cloud} cloud · {partner} partner" |
*
* @param {Partner_Dashboard_Kpi_Orgs_BadgeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_dashboard_kpi_orgs_badge = /** @type {((inputs: Partner_Dashboard_Kpi_Orgs_BadgeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Dashboard_Kpi_Orgs_BadgeInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.cloud} Cloud · ${i?.partner} Partner`)
	return /** @type {LocalizedString} */ (`${i?.cloud} cloud · ${i?.partner} partner`)
});